import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const crmPipelineReportWidget: DashboardWidgetConfiguration = {
  widgetId: "crm.pipeline-report",
  name: "CRM pipeline report",
  description: "CRM pipeline report using the reusable report-widget visualization.",
  apps: [
    "home",
    "crm",
  ],
  template: "report",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "crm.prospects",
      ...period(30),
      select: [
        {
          type: "field",
          field: "stage",
          as: "stage",
        },
        {
          type: "aggregate",
          function: "sum",
          field: "expected_value",
          as: "pipeline_value",
        },
      ],
      group_by: [
        {
          field: "stage",
        },
      ],
      order_by: [
        {
          ref: "pipeline_value",
          direction: "desc",
        },
      ],
      limit: 8,
      where: {
        type: "condition",
        field: "prospect_type",
        operator: "eq",
        value: "opportunity",
      },
    },
  },
  inputs: {
    title: "CRM pipeline report",
    subtitle: "Live RQL report",
    output: "category_series",
    visualization: "bar",
    icon: "average",
    showTimeControls: true,
  },
  dummyData: {
    value: "$128,400",
    series: [
      18,
      30,
      24,
      42,
      35,
    ],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
